module.exports = __webpack_public_path__ + "static/media/crystalcollectorTextImage.54605249.png";